import { IconStyled, IconStylesProps } from './IconStyles';

export const CalendarArrowLeft = ({
  size = 'base',
  className = '',
  fill = 'currentColor',
  transform,
  onClick,
}: Partial<IconStylesProps>) => (
  <IconStyled
    onClick={onClick}
    size={size}
    className={className}
    viewBox='0 0 14 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      style={{
        transform,
        transformOrigin: '50% 50%',
      }}
      d='M2.86 8.598a.828.828 0 0 1 0-1.16L9.68.582c.352-.316.88-.316 1.196 0l.809.809c.316.316.316.843 0 1.195L6.27 8 11.685 13.45c.316.35.316.878 0 1.195l-.81.808c-.315.317-.843.317-1.194 0l-6.82-6.855Z'
      fill={fill}
    />
  </IconStyled>
);

{
  /* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="" width="16px" height="16px" style="min-height: 16px; min-width: 16px; transform: rotate(180deg);"><path fill="currentcolor" d="M285.476 272.971 91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg> */
}

// <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16" class="" width="16px" height="16px" style="min-height: 16px; min-width: 16px;"><path fill="currentcolor" d="M9.68 8.598a.828.828 0 0 0 0-1.16L2.86.582c-.352-.316-.88-.316-1.196 0l-.809.809c-.316.316-.316.843 0 1.195L6.27 8 .855 13.45c-.316.35-.316.878 0 1.195l.81.808c.315.317.843.317 1.194 0l6.82-6.855Z"></path></svg>
